import { isNullOrUndefined } from './typeUtils';

export function isEmptyOrWhitespace(input: string | undefined): input is undefined {
  if (isNullOrUndefined(input)) {
    return true;
  }

  return input.replace(/\s/g, '').length === 0;
}

export function isNotEmptyOrWhitespace(input: string | undefined): input is string {
  return !isEmptyOrWhitespace(input);
}
